/** Minimum horizontal distance in px before a touch gesture counts as a swipe. */
export const SWIPE_THRESHOLD_PX = 50;

export type SwipeDirection = "next" | "prev";

export interface TouchPoint {
    x: number;
    y: number;
}

/** The parts of `navigator` and `window` the touch detection reads, passed in so tests need no DOM. */
export interface TouchEnvironment {
    navigator: { maxTouchPoints?: number };
    window: object;
}

/** Whether the device supports touch input: it reports touch points or knows the `touchstart` event. */
export function isTouchSupported(env: TouchEnvironment): boolean {
    return (env.navigator.maxTouchPoints ?? 0) > 0 || "ontouchstart" in env.window;
}

/**
 * Maps a gesture to a gallery step: a swipe to the left shows the next item, to the right the previous one.
 * Returns `null` below the threshold or when the gesture is at least as vertical as it is horizontal, so
 * scrolling the page over the gallery never changes the item.
 */
export function resolveSwipeDirection(start: TouchPoint, end: TouchPoint): SwipeDirection | null {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dy) >= Math.abs(dx)) {
        return null;
    }
    return dx < 0 ? "next" : "prev";
}
